import React, { lazy } from 'react';
export function DeckScreens() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1218">
      <div className="max-w-7xl mx-auto" data-id="element-1219">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1220">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight mb-6" data-id="element-1221">
            Glass Deck Railing, Window Screens & Door Screens
          </h2>
          <p className="text-lg text-slate-600" data-id="element-1222">
            Kosin's Glass can help with more than windows. The team supplies
            custom glass panels for deck railings and can repair or replace
            damaged window screens and door screens.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1223">
          <article className="bg-slate-50 rounded-2xl border border-slate-200 flex flex-col h-full overflow-hidden anim-on-scroll" data-id="element-1224">
            <div className="aspect-[5/3] w-full overflow-hidden" data-id="element-1225">
              <img src="https://cdn.magicpatterns.com/uploads/htoXmF8zKkRWKHtScGxMiw/respic4.webp" alt="Custom tempered glass panels installed in a residential deck railing" className="w-full h-full object-cover" loading="lazy" data-id="element-1226" />
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-1227">
              <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-1228">
                Glass Deck Railing Panels
              </h3>
              <p className="text-slate-600 text-lg mb-8 flex-grow" data-id="element-1229">
                Custom glass panels for deck railings help homeowners, builders
                and contractors create modern outdoor spaces with open views,
                durable tempered glass and a clean finished look.
              </p>
              <div data-id="element-1230">
                <a href="/deckglass.html" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-1231">
                  Learn About Glass Deck Railing
                </a>
              </div>
            </div>
          </article>
          <article className="bg-slate-50 rounded-2xl border border-slate-200 flex flex-col h-full overflow-hidden anim-on-scroll" data-id="element-1232">
            <div className="aspect-[5/3] w-full overflow-hidden" data-id="element-1233">
              <img src="https://cdn.magicpatterns.com/uploads/qrNnHAJR5sN6DHwJJakntj/WindoDoor.png" alt="Kosin's Glass technician replacing screen material on a residential window screen frame" className="w-full h-full object-cover" loading="lazy" data-id="element-1234" />
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-1235">
              <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-1236">
                Window & Door Screens
              </h3>
              <p className="text-slate-600 text-lg mb-8 flex-grow" data-id="element-1237">
                Damaged screens can be repaired or replaced by replacing the
                screen material, helping improve airflow and everyday use.
              </p>
              <div data-id="element-1238">
                <a href="#estimate-form" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-1239">
                  Ask About Screen Repair
                </a>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>;
}